import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    margin: 'auto',
    padding: {
      xs: '0px 24px',
      md: '0px',
    },
    '@media (min-width: 1460px)': {
      width: '1248px',
    },
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
